<template>
    <span>
        <criarevento></criarevento>
    </span>
</template>

<script>
import Criarevento from '@/components/Criar-Evento';

export default {
    name: 'cadcriarevento',
    components: {
        Criarevento
    }
};
</script>